import { useContext } from 'react';
import { AuthContext, AuthContextValue } from '../contexts/Auth';

export const useAuth = ():AuthContextValue => useContext(AuthContext);
